import { c as _c } from "react/compiler-runtime";
import { getMemberTableSubjectDisplayName } from "@components/table/members/members-table-utils";
import { Box } from "@mui-wrapper";
import { DEFAULT_FONT_FAMILY_ITALIC } from "@styles/common-styles";
import { getPrettyName } from "@utils/user-utils";
/** Renders the description from success message after removing a member */
export function RemoveMemberSuccessDescription(t0) {
  const $ = _c(17);
  const {
    member,
    subjectType,
    entityName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      fontSize: "14px",
      display: "flex",
      flexDirection: "column"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontFamily: DEFAULT_FONT_FAMILY_ITALIC,
      wordWrap: "break-word"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== member) {
    t3 = getPrettyName(member);
    $[2] = member;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <Box component="var" sx={t2}>{t3}</Box>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== subjectType) {
    t5 = getMemberTableSubjectDisplayName(subjectType);
    $[6] = subjectType;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = ` has been successfully removed from ${t5} `;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      fontFamily: DEFAULT_FONT_FAMILY_ITALIC
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== entityName) {
    t8 = <Box component="var" sx={t7}>{entityName}</Box>;
    $[9] = entityName;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t8) {
    t9 = <Box component="div">{t6}{t8}</Box>;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t4 || $[15] !== t9) {
    t10 = <Box component="div" sx={t1}>{t4}{t9}</Box>;
    $[14] = t4;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}